/** Leaves the app for another URL: the sign-in at `/api/auth/login`, and the Keycloak end-session page. One function, so a spec can replace it. */
export function navigate(url: string): void {
  window.location.assign(url);
}
